export default "__VITE_ASSET__PEyL8y4s__"